module.exports = __webpack_public_path__ + "static/media/icon-animation.8ba3be28.svg";